/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewladderstep23Inputs */

const en_letterpreviewladderstep23 = /** @type {(inputs: Letterpreviewladderstep23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registered notice`)
};

const pt_letterpreviewladderstep23 = /** @type {(inputs: Letterpreviewladderstep23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interpelação admonitória`)
};

/**
* | output |
* | --- |
* | "Registered notice" |
*
* @param {Letterpreviewladderstep23Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewladderstep23 = /** @type {((inputs?: Letterpreviewladderstep23Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewladderstep23Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewladderstep23(inputs)
	return pt_letterpreviewladderstep23(inputs)
});
export { letterpreviewladderstep23 as "letterPreviewLadderStep2" }